import { MobileVariant } from "../../types";
import { ContentContainer, ContentWrapper } from "./styled";
import React from "react";
import { VerticalLine } from "../../styled";
export const MobileContent = ({ active, children, mobileVariant, branding, }) => {
    return (React.createElement(ContentContainer, { mobileVariant: mobileVariant },
        mobileVariant === MobileVariant.VERTICAL_LINE && (React.createElement(VerticalLine, { hasMinHeight: active, active: false, branding: branding })),
        React.createElement(ContentWrapper, { mobileVariant: mobileVariant }, children)));
};
//# sourceMappingURL=index.js.map